import Vue from 'vue'
import Router from 'vue-router'
// preparationpage  仅仅为一个告知到小程序选书的页面。
const preparationpage = () => import('./pages/preparationpage')
// 下方为原页面的移动端代码
const home = () => import('./pages/home')
const cart = () => import('./pages/cart')
const order = () => import('./pages/order_list')
const orderDetail = () => import('./pages/order_detail')
const pressDetail = () => import('./pages/press_detail')
const orderShow = () => import('./pages/order_show')
const bookDetail = () => import('./pages/book_detail')
const commonLibrary = () => import('./pages/common_library')
const schoolLibrary = () => import('./pages/school_library')
const special = () => import('./pages/special') // 特色专区
const libraryList = () => import('./pages/library_list') // 本地出版社
const union = () => import('./pages/union') // 联合体专区
const sxLocal = () => import('./pages/sxLocal') // 三新现货库存
const login = () => import('./pages/login') // 登录

Vue.use(Router)

export const pageNames = {
    preparationpage:'m_preparationpage',
    home: 'm_home',
    cart: 'm_cart',
    order: 'm_order',
    orderDetail: 'm_order_detail',
    orderShow: 'm_order_show',
    press_detail: 'm_press_detail',
    book_detail: 'm_book_detail',
    common_library: 'm_common_library',
    school_library: 'm_school_library',
    special: 'm_special',
    library_list: 'm_library_list',
    union: 'm_union', // 联合体专区
    sxLocal: 'm_sx_local', // 三新现货库存
    login: 'm_login'
}

const resolvePath = (pageName) => {
    if (pageName.indexOf('/') === 0) {
        return pageName
    } else {
        return '/' + pageName
    }
}

export default {
    routes: [
        // 页面
        // {
        //     name: '',
        //     path: '/',
        //     redirect: resolvePath(pageNames.home)
        // },
        {
            name: pageNames.preparationpage,
            path: resolvePath(pageNames.preparationpage),
            component: preparationpage
        },
        {
            name: pageNames.home,
            path: resolvePath(pageNames.home),
            component: home
        },
        {
            name: pageNames.cart,
            path: resolvePath(pageNames.cart),
            component: cart
        },
        {
            name: pageNames.order,
            path: resolvePath(pageNames.order),
            component: order
        },
        {
            name: pageNames.orderDetail,
            path: resolvePath(pageNames.orderDetail) + '/:orderId',
            component: orderDetail
        },
        {
            name: pageNames.orderShow,
            path: resolvePath(pageNames.orderShow) + '/:orderInfo',
            component: orderShow
        },
        {
            name: pageNames.press_detail,
            path: resolvePath(pageNames.press_detail) + '/:obj',
            component: pressDetail
        },
        {
            name: pageNames.book_detail,
            path: resolvePath(pageNames.book_detail) + '/:book_id',
            component: bookDetail
        },
        {
            name: pageNames.common_library,
            path: resolvePath(pageNames.common_library),
            component: commonLibrary
        },
        {
            name: pageNames.school_library,
            path: resolvePath(pageNames.school_library),
            component: schoolLibrary
        },
        {
            name: pageNames.special,
            path: resolvePath(pageNames.special),
            component: special
        },
        {
            name: pageNames.library_list,
            path: resolvePath(pageNames.library_list),
            component: libraryList
        },
        {
            name: pageNames.union,
            path: resolvePath(pageNames.union),
            component: union
        },
        {
            name: pageNames.sxLocal,
            path: resolvePath(pageNames.sxLocal) + '/:activitytag',
            component: sxLocal
        },
        {
            name: pageNames.login,
            path: resolvePath(pageNames.login),
            component: login
        }
    ],
    scrollBehavior (to, from, savedPosition) {
        // 从二级页面返回首页时,savedPosition会存在,此时直接返回savedPosition所在的微信,其他没有savedPosition的时候都滚动到头部
        if (savedPosition) {
            return savedPosition
        } else {
            return { x: 0, y: 0 }
        }
    }
}



// WEBPACK FOOTER //
// ./src/mobile/router.js